import React from "react";
import { Route, Routes } from "react-router-dom";
import { ZonesPage } from "./pages/zones-page/sidebar";
import { ArcBaseContent, ArcBaseSidebar } from "@src/core/components";
import { ArcGoogleMap } from "@src/core/controllers";
import ZonesMap from "./pages/zones-page/map";
import { ArcStack } from "@src/core/ui";
import { CreateZonePage } from "./pages/create-zone";
import { EditZonePage } from "./pages/edit-zone";
import { EditSafeLandZonePage } from "./pages/edit-safe-land-zone";
import { useGetSafeLandZonesQuery } from "@src/features/zones/redux";
import { VARIANT_SAFE_LAND } from "./pages/zones-page/types";
import { safeLandZoneToZoneEntity } from "./utils";
import { useGetZonesQuery } from "@src/core/features";

const ZonesMapWrapper: React.FC = () => {
  const { data: zones } = useGetZonesQuery();
  const { data: safeLandZones } = useGetSafeLandZonesQuery();
  const safeLandAsZones = (safeLandZones ?? []).map(safeLandZoneToZoneEntity);
  const zonesWithSafeLand = [...(zones ?? []), ...safeLandAsZones];
  return <ZonesMap zones={zonesWithSafeLand} />;
};

const ZonesFeature: React.FC = () => {
  return (
    <ArcStack direction='row'>
      <ArcBaseSidebar>
        <Routes>
          <Route path="" element={<ZonesPage />} />
          <Route path="create" element={<CreateZonePage />} />
          <Route path="create-safe-land" element={<CreateZonePage variant={VARIANT_SAFE_LAND} />} />
          <Route path="edit/:id" element={<EditZonePage />} />
          <Route path="edit-safe-land/:id" element={<EditSafeLandZonePage />} />
        </Routes>
      </ArcBaseSidebar>
      <ArcBaseContent>
        <ArcGoogleMap>
          <ZonesMapWrapper />
        </ArcGoogleMap>
      </ArcBaseContent>
    </ArcStack>
  );
};

export default ZonesFeature;
